/* eslint-disable array-callback-return */
import { valuesIn } from 'lodash';

export const renderItem = (list) => {
    return list?.split(',').map((d) => {
        return {
            value: d,
            label: d,
        };
    });
};
export const renderListStyleLiked = (list) => {
    return list?.split(',').map((item) => {
        return {
            title: capitalizeString(item),
            value: capitalizeString(item),
            isActive: true,
            isShow: true,
        };
    });
};
export const createFilterList = (personaString) => {
    if (personaString) {
        return personaString?.split(',').map((item) => {
            return {
                title: item,
                value: item,
                isActive: true,
                isShow: true,
            };
        });
    } else {
        return [];
    }
};
export const renderListStyleQuizLiked = (answers, questions) => {
    const listAnswers = valuesIn(answers);
    const listQuestions = valuesIn(questions);
    return listAnswers
        .filter((q) => q.value === 'LIKE')
        .map((item) => {
            const questionLiked = listQuestions.find((ques) => ques.id === item.questionId);
            if (questionLiked) {
                return {
                    title: capitalizeString(questionLiked?.title),
                    value: capitalizeString(questionLiked?.title),
                    image: questionLiked.imageUrl,
                    isActive: true,
                    isShow: true,
                    id: questionLiked.id,
                };
            }
        });
};

export const getAnsweredQuestions = (answers, questions) => {
    const listAnswers = valuesIn(answers);
    const listQuestions = valuesIn(questions);
    return listAnswers
        .filter((q) => q.value)
        .map((item) => {
            const questionAnswered = listQuestions.find((ques) => ques.id === item.questionId);
            if (questionAnswered) {
                return {
                    title: capitalizeString(questionAnswered?.title),
                    value: item.value,
                    isActive: true,
                    isShow: true,
                };
            }
        });
};
export const capitalizeString = (str, lower = false) =>
    (lower ? str.toLowerCase() : str).replace(/(?:^|\s|["'([{])+\S/g, (match) => match.toUpperCase());
